import produce from 'immer';
import { types, IEmailTemplate, IEmailTemplatesResponse } from './types';

export interface IEmailTemplatesInitialState {
    templates: IEmailTemplatesResponse | undefined;
    fetchingTemplates: boolean;
    fetchingTemplatesError: null | any;

    currentTemplate: IEmailTemplate | null;

    savingTemplate: boolean;
    savingTemplateError: null | any;

    deletingTemplate: boolean;
    deletingTemplateError: null | any;

    sendingEmail: boolean;
    sendingEmailError: null | any;
}

const initialState: IEmailTemplatesInitialState = {
    templates: undefined,
    fetchingTemplates: false,
    fetchingTemplatesError: null,

    currentTemplate: null,

    savingTemplate: false,
    savingTemplateError: null,

    deletingTemplate: false,
    deletingTemplateError: null,

    sendingEmail: false,
    sendingEmailError: null,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case types.FETCH_EMAIL_TEMPLATES:
            return produce(state, draft => {
                draft.fetchingTemplates = true;
                draft.fetchingTemplatesError = null;
            });
        case types.FETCH_EMAIL_TEMPLATES_SUCCESS:
            return produce(state, draft => {
                draft.templates = payload;
                draft.fetchingTemplates = false;
            });
        case types.FETCH_EMAIL_TEMPLATES_FAIL:
            return produce(state, draft => {
                draft.fetchingTemplates = false;
                draft.fetchingTemplatesError = payload;
            });

        case types.SET_CURRENT_TEMPLATE:
            return produce(state, draft => {
                draft.currentTemplate = payload;
            });

        case types.SAVE_EMAIL_TEMPLATE:
            return produce(state, draft => {
                draft.savingTemplate = true;
                draft.savingTemplateError = null;
            });
        case types.SAVE_EMAIL_TEMPLATE_SUCCESS:
            return produce(state, draft => {
                draft.savingTemplate = false;
                draft.currentTemplate = payload;
                // Update the list if it exists
                if (draft.templates?.data?.data) {
                    const index = draft.templates.data.data.findIndex(item => item._id === payload._id);
                    if (index !== -1) {
                        draft.templates.data.data[index] = payload;
                    } else {
                        draft.templates.data.data.unshift(payload);
                        draft.templates.totalCount += 1;
                    }
                }
            });
        case types.SAVE_EMAIL_TEMPLATE_FAIL:
            return produce(state, draft => {
                draft.savingTemplate = false;
                draft.savingTemplateError = payload;
            });

        case types.DELETE_EMAIL_TEMPLATE:
            return produce(state, draft => {
                draft.deletingTemplate = true;
                draft.deletingTemplateError = null;
            });
        case types.DELETE_EMAIL_TEMPLATE_SUCCESS:
            return produce(state, draft => {
                draft.deletingTemplate = false;
                // Remove the item from the list if it exists
                if (draft.templates?.data?.data) {
                    draft.templates.data.data = draft.templates.data.data.filter(item => item._id !== payload);
                    draft.templates.totalCount = Math.max(0, draft.templates.totalCount - 1);
                    draft.templates.results = Math.max(0, draft.templates.results - 1);
                }
                if (draft.currentTemplate?._id === payload) {
                    draft.currentTemplate = null;
                }
            });
        case types.DELETE_EMAIL_TEMPLATE_FAIL:
            return produce(state, draft => {
                draft.deletingTemplate = false;
                draft.deletingTemplateError = payload;
            });

        case types.SEND_EMAIL:
            return produce(state, draft => {
                draft.sendingEmail = true;
                draft.sendingEmailError = null;
            });
        case types.SEND_EMAIL_SUCCESS:
            return produce(state, draft => {
                draft.sendingEmail = false;
            });
        case types.SEND_EMAIL_FAIL:
            return produce(state, draft => {
                draft.sendingEmail = false;
                draft.sendingEmailError = payload;
            });

        default:
            return state;
    }
};

export { reducer };
